module.exports = __webpack_public_path__ + "static/media/list-asset.5fa5057e.png";